import React from 'react';
import projectThumb from '../assets/images/xpharma-preview.png';
import { Link } from 'react-router-dom';
import ExternalLinks from '../Lib/ExternalLinks';

function CallToAction({ className }) {
    return (
        <>
            <section className={`appie-project-area pb-100 ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-project-box wow animated slideInUp"
                                data-wow-duration="1000ms"
                                data-wow-delay="0ms"
                            >
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="appie-project-content">
                                            <h3 className="title">
                                                Get started today with XPharma.
                                            </h3>
                                            <p>Download the app directly or book a demo, it's all free.</p>
                                            <div className="appie-download-content">
                                                <ul>
                                                    <li>
                                                        <Link to="/download">
                                                            <i className="fal fa-download" /> Download now
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <a className="item-2" href={ExternalLinks.demo_booking}>
                                                            <i className="fal fa-calendar" /> Schedule a demo
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="appie-project-thumb">
                                    <img src={projectThumb} alt="" className='w-75'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CallToAction;
